/** Minimum characters for story / reflection prompts (Trello #79). */
export const STORY_MIN_CHARS = 30;
